<template>
  <layout
    title="Developer-first face authentication"
    :transparent="true"
    class="overflow-x-hidden"
  >
    <highlightSection
      backgroundImage="/storage/images/home/decentralized_authentication_Youverse.jpg"
      altImage="Decentralized Authentication Youverse"
      title="Verify identities, detect fraud. Instantly."
      subtitle="Accelerate customer onboarding and combat fraud with fully automated biometric authentication and ID verification."
      leftButton="Book a Demo"
      urlLeftButton="book-a-meeting"
    />
    <section2 />
    <partners />
    <section4 />
    <div class="my-24">
      <cta
        title="Get started"
        text="Simplify customer identity verification and authentication with a single click."
        buttonText="Book a Demo"
        buttonLink="/book-a-meeting"
        target="_blank"
      />
    </div>
    <section6 />
    <section7 />
    <div class="my-20">
      <cta
        title="Talk to our experts"
        text="Your competitors are already ahead. Are you ready?"
        buttonText="Contact us"
        buttonLink="/company#contactus"
      />
    </div>

    <section8 />
  </layout>
</template>

<script>
const layout = () =>
  import(/* webpackChunkName: "layout" */ "../Components/Layout/layout.vue");

const highlightSection = () =>
  import(
    /* webpackChunkName: "highlightSection" */ "../Components/Layout/highlightSection.vue"
  );

const section2 = () =>
  import(
    /* webpackChunkName: "section2" */ "../Components/Layout/HomePage/section2.vue"
  );

const partners = () =>
  import(
    /* webpackChunkName: "partners" */ "../Components/Layout/HomePage/partners.vue"
  );

const section4 = () =>
  import(
    /* webpackChunkName: "section4" */ "../Components/Layout/HomePage/section4.vue"
  );

const cta = () =>
  import(/* webpackChunkName: "cta" */ "../Components/Layout/cta.vue");

const section6 = () =>
  import(
    /* webpackChunkName: "section6" */ "../Components/Layout/HomePage/section6.vue"
  );

const section7 = () =>
  import(
    /* webpackChunkName: "section7" */ "../Components/Layout/HomePage/section7.vue"
  );

const section8 = () =>
  import(
    /* webpackChunkName: "section8" */ "../Components/Layout/HomePage/section8.vue"
  );

export default {
  components: {
    layout,
    highlightSection,
    section2,
    partners,
    section4,
    cta,
    section6,
    section7,
    section8,
  },
  props: {
    errors: Object,
  },
};
</script>

